<template>
    <div>
        <el-container>
            <!--文章内容部分-->
            <el-main style="padding: 0;">
                <div style="width: 95%;margin-left: 50px">
                <div style="background: #ffffff;padding: 50px">
                    <!--{{data}}-->
                    <!--{{articleId}}-->
                    <!--{{freshen}}-->

                    <div class="content-container">
                        <h1 class="title">{{title}}</h1>
                        <div class="info">
                            <p>创建时间：{{data.createTime}}</p>
                            <!--<p>最近编辑时间：{{data.updateTime}}</p>-->
                            <!--<p>编辑次数：{{data.editNum}}</p>-->
                            <p>文章浏览量：{{data.viewCount}}</p>
                        </div>
                        <div class="article-content" v-html="content"/>

                        <div style="margin-top: 60px">
                            <div v-if="preArticleId" style="float: left">
                                <el-button @click="gotoPre" icon="el-icon-arrow-left">上一篇:{{preArticleTitle}}</el-button>
                            </div>
                            <div v-if="nextArticleId" style="float: right">
                                <el-button @click="gotoNext">下一篇:{{nextArticleTitle}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                            </div>
                        </div>
                    </div>

                    <!--发表评论-->
                    <div class="comment">
                        <el-form :model="commentForm" :rules="rules" ref="commentForm" label-width="100px"
                                 class="comment-Form">
                            <el-form-item label="评论内容" prop="commentContent">
                                <el-input type="textarea" placeholder="请务必要文明发言"
                                          v-model="commentForm.commentContent"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="postComment('commentForm')">评论</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <!--{{commentList}}-->
                    <!--评论列表-->
                    <div class="article-list-main">
                        <div class="article-list-container">
                            <el-card class="article-list-item-container" v-for="(item,index) in commentList"
                                     :key="index">
                                <div style="display: flex">
                                    <el-avatar :size="30" :src="item.tbUser.avatar"></el-avatar>
                                    <div style="margin-left: 16px;margin-top: -15px"><h4>{{item.tbUser.nickName}}</h4>
                                    </div>
                                </div>
                                <div><h3>{{item.content}}</h3></div>
                                <div><h6>{{item.createTime}}</h6></div>
                                <!--item.userId:{{item.tbUser.id}}-->
                                <!--userId:{{userId}}-->
                                <div v-if="item.tbUser.id === userId">
                                    <el-button class="del_button" @click="delComment(item.id)">删除该评论</el-button>
                                </div>
                            </el-card>
                        </div>

                        <div v-if="total">
                            <el-pagination
                                    class="page"
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    @prev-click="handlePrevClick"
                                    @next-click="handleNextClick"
                                    :current-page="currentPage"
                                    :page-sizes="[10 , 20, 30, 40 ,50 ,60]"
                                    :page-size="30"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total=total>
                            </el-pagination>
                        </div>
                    </div>

                    <!--收藏-->
                    <div class="favorite" v-if="favorite===0"><img class="img" @click="favoriteToYes"
                                                                   src="../assets/img/favorite_no.png"></div>
                    <div class="favorite" v-else-if="favorite===1"><img class="img" @click="favoriteToNo"
                                                                        src="../assets/img/favorite_yes.png"></div>
                </div>

            </div>
            </el-main>

            <!--<el-aside width="300px" style="margin-right: 30px">-->
            <el-aside width="300px" style="margin-left: 50px">
                <el-card style="height: 200px">
                    <h4>希望是附丽于存在的，有存在，便有希望，有希望便是光明</h4>
                </el-card>

                <el-card class="box-card" style="margin-top: 10px;position: fixed;width: 298px">
                    <div slot="header" class="clearfix">
                        <span>文章目录</span>
                    </div>
                    <div v-for="item in h2" :key="item" class="aside-list">
                        <ul class="aside-list_ul">
                            <li class="aside-list_ul_li" @click="gotoEle(item.offsetTop)">
                                <a>{{item.innerHTML}}</a>
                            </li>
                        </ul>
                    </div>
                    <!--<div v-for="item in childrens" :key="item" class="aside-list">-->
                        <!--<div v-for="item2 in item.children" :key="item2">-->
                            <!--<ul class="aside-list_ul">-->
                                <!--<li v-if="item2.nodeName==='H2' || item2.nodeName==='H3'" @click="gotoEle(item2.offsetTop)" class="aside-list_ul_li">-->
                                    <!--<a>{{item2.nodeName}}</a>-->
                                    <!--<a>{{item2.innerHTML}}</a>-->
                                <!--</li>-->
                            <!--</ul>-->
                        <!--</div>-->
                    <!--</div>-->


                </el-card>
            </el-aside>

        </el-container>


    </div>
</template>

<script>
    import Prism from 'prismjs';
    import {getArticleDetailByArticleId} from "@/api/get";
    import {addFavorite, delFavorite, checkFavoriteList} from "@/api/favorite";
    import {postComment, listByArticleId, delComment} from "@/api/comment";

    export default {
        name: "ArticleDetail",
        inject:['reload'],
        data() {
            return {
                h1: "",
                h2: [],

                userId: "",

                articleId: "", //文章id
                preArticleId:"", //前一篇文章id
                preArticleTitle:"", //前一篇文章标题
                nextArticleId:"", //后一篇文章id
                nextArticleTitle:"", //后一篇文章标题

                data: undefined,
                title: '',
                content: '',
                favorite: 0,
                addFavoriteData: {
                    userId: "",
                    articleId: "",
                    columnId: "",
                    title: "",
                    summary: "",
                },
                favoriteList: [],

                commentForm: {
                    commentContent: "",
                },

                postCommentData: {
                    userId: "",
                    articleId: "",
                    title: "",
                    parentCommentId: "",
                    parentContent: "",
                    content: "",
                    userAvatar: "",
                    userName: "",
                },

                // isComment:false,
                // isDelComment:false,
                freshen: 0,
                commentList: [],

                total: 0,
                currentPage: 1,
                pageNum: 1,
                pageSize: 30,
            }
        },

        watch: {
            /*监听是否需要刷新数据*/
            freshen: {
                handler() {
                    this.commentForm.commentContent = "";
                    this.getCommentListByArticleId(this.articleId, this.pageNum, this.pageSize);
                },
                immediate: true
            },
            $route: {
                handler() {
                    // this.commentForm.commentContent = "";
                    // this.getCommentListByArticleId(this.articleId,this.pageNum,this.pageSize);
                    // window.document.title = this.$route.meta.title || ""
                    // this.$message({
                    //     showClose: true,
                    //     message: this.$route.params.articleId,
                    //     type: 'error'
                    // });
                    this.getArticleDetail(this.$route.params.articleId)
                },
                immediate: true
            },
        },

        created() {
            this.articleId = this.$route.params && this.$route.params.articleId;
            this.userId = this.$store.state.user.userId;

            //收藏相关
            this.addFavoriteData.userId = this.$store.state.user.userId;
            this.addFavoriteData.articleId = this.articleId;

            if (this.userId != null) {
                this.checkIsFavorite(this.$store.state.user.userId);
            }
            this.getArticleDetail(this.articleId);

            //评论相关
            this.postCommentData.userId = this.$store.state.user.userId;
            this.postCommentData.articleId = this.articleId;
            this.postCommentData.userAvatar = this.$store.state.user.avatar;
            this.postCommentData.userName = this.$store.state.user.nickname;

            this.getCommentListByArticleId(this.articleId, this.pageNum, this.pageSize);
        },

        mounted() {
            //获取h2标签的元素
            this.$nextTick(()=> {
                setTimeout(()=> {
                    let el = document.getElementsByTagName('h2');

                    if(el) {
                        this.h2 = el
                    }
                })
            })
        },

        methods: {
            //点击文章目录跳转
            gotoEle(offsetTop) {
                window.scrollTo({'behavior': 'smooth', 'top': offsetTop})
            },
            //前一篇文章
            gotoPre(){
                this.$router.push('/article/articleDetail/' + this.preArticleId);
                this.reload()
            },
            //后一篇文章
            gotoNext(){
                this.$router.push('/article/articleDetail/' + this.nextArticleId);
                this.reload()
            },

            //获取文章详情内容
            getArticleDetail(articleId) {
                // console.log(articleId)
                getArticleDetailByArticleId(articleId).then(response => {
                    // console.log("getArticleDetail这里"+JSON.stringify(response.data))
                    this.data = response.data.contentArticle
                    this.title = response.data.contentArticle.title
                    this.content = response.data.contentArticle.content //这就是我从后台获取到的字符串值
                    this.timer = setTimeout(() => {
                        Prism.highlightAll() // 这里加定时器让它后执行，不然没效果
                    }, 0)

                    this.preArticleId = response.data.preArticleId
                    this.preArticleTitle = response.data.preArticleTitle
                    this.nextArticleId = response.data.nextArticleId
                    this.nextArticleTitle = response.data.nextArticleTitle

                    window.document.title = this.title
                });
            },

            //检查文章是否被该用户收藏
            checkIsFavorite(userId) {
                checkFavoriteList(userId).then(response => {
                    this.favoriteList = response.rows;
                    for (let i = 0; i < this.favoriteList.length; i++) {
                        if (this.articleId === this.favoriteList[i].articleId) {
                            this.favorite = 1;
                        }
                    }
                });
            },

            //收藏
            favoriteToYes() {
                this.addFavoriteData.columnId = this.data.columnId;
                this.addFavoriteData.title = this.title;
                this.addFavoriteData.summary = this.data.summary;
                addFavorite(this.addFavoriteData).then(response => {
                    if (response.code === 200) {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'success'
                        });
                        this.favorite = 1
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'error'
                        });
                    }
                });

            },

            //取消收藏
            favoriteToNo() {
                delFavorite(this.addFavoriteData.userId, this.addFavoriteData.articleId).then(response => {
                    if (response.code === 200) {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'success'
                        });
                        this.favorite = 0
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'error'
                        });
                    }
                });
            },

            //发布评论
            postComment(formName) {
                this.postCommentData.title = this.title;
                this.postCommentData.content = this.commentForm.commentContent;

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        postComment(this.postCommentData).then(response => {
                            if (response.code === 200) {
                                this.$message({
                                    showClose: true,
                                    message: response.msg,
                                    type: 'success'
                                });
                                // this.isComment = true;
                                this.freshen = this.freshen + 1
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.msg,
                                    type: 'error'
                                });
                            }

                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: "出现问题了",
                            type: 'error'
                        });
                    }
                });
            },

            //根据文章id获取所有评论
            getCommentListByArticleId(articleId, pageNum, pageSize) {
                listByArticleId(articleId, pageNum, pageSize).then(response => {
                    if (response.code === 200) {
                        this.commentList = response.rows;
                        this.total = response.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.msg,
                            type: 'error'
                        });
                    }
                });
            },

            //删除评论
            delComment(commentId) {
                this.$confirm('确定要删除该评论吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delComment(commentId).then(response => {
                        if (response.code === 200) {
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'success'
                            });
                            this.freshen = this.freshen + 1;
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            },

            //处理分页的内容
            handleSizeChange(val) {
                this.pageSize = val
                this.getCommentListByArticleId(this.articleId, this.pageNum, val)
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.getCommentListByArticleId(this.articleId, val, this.pageSize)
            },
            handlePrevClick(val) {
                this.getCommentListByArticleId(this.articleId, val, this.pageSize)
            },
            handleNextClick(val) {
                this.getCommentListByArticleId(this.articleId, val, this.pageSize)
            },

        }
    }
</script>

<style scoped>
    .content-container {
        position: relative;
    }

    .info {
        margin-top: 30px;
        display: flex;
        /*text-align: center;*/
    }

    .info p {
        /*margin-left: 50px;*/
        /*text-align: center;*/
        margin: 0 auto;
        width: auto;
        font-size: small;
        color: gray;
    }

    .article-content {
        margin-top: 60px;
    }

    .title {
        text-align: center;
        color: black;
    }

    .favorite {
        right: 2%;
        left: inherit;
        position: fixed;
        top: 80%;
    }

    .img {
        width: 60px;
    }

    .comment {
        margin-top: 160px;
        margin-bottom: 60px;
    }

    .article-list-main {
        padding: 10px;
        width: 100%;
        border-radius: 6px;
    }

    .article-list-item-container {
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        padding-left: 30px;
        position: relative;
    }

    .page {
        float: right;
        margin-top: 30px;
        margin-right: 30px;
    }

    .del_button {
        position: absolute;
        right: 3%;
        bottom: 16%;
    }

    /*右侧栏*/
    .aside-list_ul {
        list-style: none;
        margin: 0px;
        padding: 0px;
    }
    .aside-list_ul_li {
        /*margin: 12px;*/
        /*margin-left: 10px;*/
    }
    .aside-list_ul_li a {
        font-size: 16px;
        color: #000;
        display: inline-block;
        text-align: left;
        list-style: none;
        margin: 10px;
    }
    .aside-list_ul_li:hover {
        background: #E4E6E9;
        border-radius: 9px;
    }
    .aside-list_ul-active li {
        background: #E4E6E9;
        color: white;
    }
</style>
